
    import I18n from '@canvas/i18n/i18nObj';
    
      import 'translations/direct_share_user_modal';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('direct_share_user_modal');
  